import { Feature } from '@yandex/ymaps3-types/packages/clusterer';

import { styles } from './PickupCluster.styles';

interface PickupClusterProps {
  features: Feature[];
  onClick: (features: Feature[]) => void;
}

export function PickupCluster({ features, onClick }: PickupClusterProps) {
  const slots = styles();

  return (
    <button
      className={slots.cluster()}
      onClick={() => onClick(features)}
    >
      <span className={slots.count()}>{features.length}</span>
    </button>
  );
}
